import SEOArticleLayout from "@/components/feature/SEOArticleLayout";

const IMAGE = "https://readdy.ai/api/search-image?query=Two%20elegant%20notebooks%20side%20by%20side%20on%20cream%20desk%20one%20with%20grid%20pattern%20one%20minimal%2C%20comparison%20concept%2C%20warm%20morning%20light%2C%20clean%20Scandinavian%20workspace%2C%20soft%20beige%20and%20taupe%20tones&width=900&height=1100&seq=seo-article-vs-notion-v3&orientation=portrait";

export default function VsNotionPage() {
  return (
    <SEOArticleLayout
      title="Hipobuy Spreadsheet vs Notion : Le Comparatif"
      subtitle="Comparaison entre le hipobuy spreadsheet et Notion pour le suivi e-commerce. Lequel choisir pour gérer vos produits et analyser vos ventes ?"
      heroImageUrl={IMAGE}
      heroImageAlt="Hipobuy Spreadsheet vs Notion"
    >
      <section className="mb-10">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">Deux outils, deux philosophies</h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-3">
          Notion est un excellent outil de gestion de connaissances et de projets. Mais pour le suivi e-commerce, le <strong>hipobuy spreadsheet</strong> a été conçu spécifiquement pour répondre aux besoins des vendeurs. Voici comment ces deux outils se comparent.
        </p>
      </section>

      <section className="mb-10">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">Comparaison point par point</h2>
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="border-b border-foreground-200">
                <th className="py-3 px-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider whitespace-nowrap">Critère</th>
                <th className="py-3 px-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider whitespace-nowrap">Notion</th>
                <th className="py-3 px-3 text-xs font-semibold text-primary-600 uppercase tracking-wider whitespace-nowrap">Hipobuy Spreadsheet</th>
              </tr>
            </thead>
            <tbody>
              {[
                ["Spécialisation e-commerce", "Outil généraliste", "Spécialisé e-commerce"],
                ["Automatisation des données", "Limitée, manuelle", "Complète et automatique"],
                ["Suivi des prix concurrents", "Non disponible", "Intégré"],
                ["Modèles e-commerce", "À créer soi-même", "Prêts à l'emploi"],
                ["Analyse de tendances", "Manuelle", "Automatique avec alertes"],
                ["Intégrations natives", "API complexe", "Plug-and-play"],
                ["Vitesse de mise en place", "Plusieurs jours", "Quelques minutes"],
              ].map((row, i) => (
                <tr key={i} className="border-b border-background-200">
                  <td className="py-3 px-3 text-xs font-medium text-foreground-800 whitespace-nowrap">{row[0]}</td>
                  <td className="py-3 px-3 text-xs text-foreground-500">{row[1]}</td>
                  <td className="py-3 px-3 text-xs font-medium text-primary-700">{row[2]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <section className="mb-10">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">Notion ou Hipobuy Spreadsheet ?</h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-3">
          Notion est parfait pour la documentation et la gestion de projet. Mais si votre priorité est le suivi e-commerce — avec automatisation, analyse concurrentielle et optimisation des ventes — le <strong>hipobuy spreadsheet</strong> est le choix évident. C'est un outil fait par et pour les vendeurs en ligne.
        </p>
      </section>

      <div className="mt-8 p-6 bg-accent-50 rounded-2xl border border-accent-100 text-center">
        <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">Testez la différence</h3>
        <p className="text-sm text-foreground-500 mb-4">Découvrez pourquoi le hipobuy spreadsheet est l'outil préféré des vendeurs e-commerce.</p>
        <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-50 rounded-full text-sm font-semibold uppercase tracking-wider whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer">
          Accéder à la Plateforme
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>
    </SEOArticleLayout>
  );
}